import React from "react";
import { Typography } from "antd";
import { useIntl } from "react-intl";
import { getLocalPhoneNumber } from "../../../components/util/helpers";
const { Title, Text } = Typography;

const PatientDetails = (props) => {
  const { patient } = props;
  const intl = useIntl();
  const street =
    patient && patient["address"] && patient["address"]["street"]
      ? `${patient["address"]["street"].trim()} ${
          patient["address"]["house_number"]
        }`
      : "-";
  const city =
    patient && patient["address"] && patient["address"]["city"] !== undefined
      ? patient["address"]["city"]
      : "-";
  const fullName = patient.first_name + " " + patient.surename;
  const phone = patient.contact_info.mobile_number
    ? getLocalPhoneNumber(patient.contact_info.mobile_number)
    : patient.contact_info.phone_number
    ? getLocalPhoneNumber(patient.contact_info.phone_number)
    : null;
  return (
    <div
      className="borderedSection"
      style={{
        width: "100%",
        padding: "0 10px",
        border: "1px dashed",
        paddingBottom: "5px",
      }}
    >
      <Title level={4}>
        {intl.formatMessage({
          id: "app.work_diary_print.eligible_details",
        })}
      </Title>
      <div
        style={{
          width: "max-content",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Text>{patient && fullName}</Text>
        <Text>{patient && patient.local_id_number}</Text>
        <Text>{patient && street ? `${city}, ${street}` : city}</Text>
        {phone && <Text>{phone}</Text>}
      </div>
    </div>
  );
};

export default PatientDetails;
